import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CasesHero from './components/CasesHero';
import CasesList from './components/CasesList';
import CtaSection from '@/pages/home/components/CtaSection';

export default function CasesPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <CasesHero />
        <CasesList />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
